import React, { useEffect, useState } from 'react';
import TableCrud from '../../components/TableCrud';
import Api, { exceptionNotificationAPI } from '../../services/api';


const CultureFormIndex = () => {

    const columns = [
        {
            label: "Nome",
            name: "name"
        },
        {
            label: "Empresa",
            name: "tenant.name",
            visible: true
        },
        {
            label: "Ativo",
            name: "isActive"
        },
    ]

    return (
        <TableCrud title={"Cultura"} table={"culture"} columns={columns}/>
    );
}

export default CultureFormIndex;
